import React from "react";
import { DropdownCheckIcon } from "../../Icons";

const SelectedCheckIcon = () => {
  return (
    <div className="absolute w-6 h-6 flex justify-center right-0 -top-1 rounded-full shadow border-2 border-white bg-primary-bg">
      <DropdownCheckIcon />
    </div>
  );
};

export default SelectedCheckIcon;
